<div class="bg-red-500 py-4 w-[400px] rounded-lg shadow-lg">

  <div class="flex items-center px-4 mb-2">
    <lucide-icon name="AlertCircle" class="w-6 h-6 text-white mr-3 flex-shrink-0"></lucide-icon>
    <span class="text-white font-bold text-lg">{{ message }}</span>
  </div>


  <div class="text-red-100 text-sm px-4 pb-3" role="alert">
    <span class="block">{{ details }}</span>
  </div>


  <button
    *ngIf="fullDetails"
    class="ml-4 bg-red-700 hover:bg-red-600 text-white text-xs py-2 px-3 rounded focus:outline-none focus:shadow-outline flex items-center transition-colors duration-200"
    (click)="toggleDetail()">
    <lucide-icon
      [name]="showDetail ? 'ChevronUp' : 'ChevronDown'"
      class="w-4 h-4 mr-1">
    </lucide-icon>
    <span>{{ showDetail ? 'Hide' : 'Show' }} Technical Details</span>
  </button>
  <div *ngIf="showDetail" class="mx-4 mt-3 p-3 bg-red-900 bg-opacity-50 text-red-100 text-xs rounded">
    <pre class="whitespace-pre-wrap m-0 p-0 font-mono">{{ fullDetails }}</pre>
  </div>
</div>
